import * as React from "react";
import { forwardRef } from "react";
const SvgIconColumns = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.1367 9H2.13672V11H13.1367V9ZM13.1367 5H2.13672V7H13.1367V5ZM17.1367 13V9H15.1367V13H11.1367V15H15.1367V19H17.1367V15H21.1367V13H17.1367ZM2.13672 15H9.13672V13H2.13672V15Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconColumns);
export { ForwardRef as ReactComponent };
